import { jsx as i } from "react/jsx-runtime";
import { useState as m } from "react";
import { Ui as g } from "../Ui/Ui.js";
import { cx as a } from "../apps/ui/styled-system/css/cx.js";
import { css as n } from "../apps/ui/styled-system/css/css.js";
function v({
  symbol: o,
  size: r = "medium",
  className: t,
  ...d
}) {
  const c = `${g.useUi().assetsBaseUrl}/token-icons`, e = `${c}/fallback.svg`, [s, l] = m(
    o ? `${c}/${o.toLowerCase()}.svg` : e
  );
  return typeof r == "string" && (r = { large: 32, medium: 24 }[r]), /* @__PURE__ */ i(
    "div",
    {
      className: a(
        n({
          background: "var(--background-color-th_badge)",
          border: "3px solid var(--background-color-th_badge)",
          borderRadius: "50%",
          display: "grid",
          overflow: "hidden",
          placeItems: "center"
        }),
        t
      ),
      style: {
        height: r,
        width: r
      },
      children: /* @__PURE__ */ i(
        "img",
        {
          alt: o,
          className: a(
            n({
              display: "block"
            }),
            t
          ),
          height: r - 6,
          onError: () => l(e),
          src: s,
          title: o,
          width: r - 6,
          ...d
        }
      )
    }
  );
}
export {
  v as TokenIcon
};
//# sourceMappingURL=TokenIcon.js.map
